import { MapPage } from '$pages/map/map';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ViewProvider } from './view';

@Injectable()
export class MapProvider {

  constructor(private viewProvider: ViewProvider) {
  }

  public openMap(place = null): Observable<any> {
    return Observable.create((observer) => {
      let params = {
        neLat: -12.315536,
        neLng: -39.013266,
        swLat: -12.155784,
        swLng: -38.868404,
        defaultLat: -12.2555592,
        defaultLng: -38.96430279999998,
        place: place
      };

      this.viewProvider.showModalPage(MapPage, params, (place) => {
        if (place) {
          observer.next(place);
        }
        observer.complete();
      });
    });
  }

  public getPlace(place = null): Observable<any> {
    return Observable.create((observer) => {
      this.openMap(place).subscribe(
        (place) => {
          if (place) {
            observer.next(place);
            observer.complete();
          }
          observer.complete();
        });
    });
  }

  public parsePlace(place): any {
    let address: any;
    address = [];

    address.name = place.name;
    address.street_number = this.getAddressComponents(place, 'street_number');
    address.route = this.getAddressComponents(place, 'route');
    address.postal_code = this.getAddressComponents(place, 'postal_code');
    address.sublocality = this.getAddressComponents(place, 'sublocality_level_1');
    address.city = this.getAddressComponents(place, 'administrative_area_level_2');
    address.state = this.getAddressComponents(place, 'administrative_area_level_1');
    address.country = this.getAddressComponents(place, 'country');
    address.lat = place.geometry.location.lat();
    address.lng = place.geometry.location.lng();

    return address;
  }

  private getAddressComponents(place, type): string {
    let c;

    for (let x = 0; x < place.address_components.length; x++) {
      c = place.address_components[x];

      for (let y = 0; y < c.types.length; y++) {
        if (c.types[y] == type) return c.long_name;
      }
    }

    return;
  }
}


// WEBPACK FOOTER //
// ./src/providers/map.ts